import React, { useContext, useEffect, useState, useRef } from 'react';

import { Container } from 'react-bootstrap';
import PortfolioContext from '../../context/context';

import gsap from 'gsap';
import { useIntersection } from 'react-use';
import AnimatedText from '../AnimatedText/AnimatedText';
import { TransitionPortal } from 'gatsby-plugin-transition-link';
import BlogsCard from '../BlogsCard';
import NewStrokedLink from '../NewStrokedLink/NewStrokedLink';


const BlogsBlock = () => {
  const { blogs } = useContext(PortfolioContext);
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const layoutContents = useRef();
  const transitionCover = useRef();
  // All the ref to be observed
  const intersection = useIntersection(sectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);



  const exitHorizontal = ({ length }, direction) => {
    const seconds = length;

    const directionTo = direction === 'left' ? '-100%' : '100%';
    const directionFrom = direction === 'left' ? '100%' : '-100%';

    return gsap
      .timeline()
      .set(transitionCover.current, { x: directionFrom, display: 'block' })
      .to(transitionCover.current, {
        x: '0%',
        ease: 'power1.easeInOut',
        duration: seconds / 2,
      })
      .set(layoutContents.current, { opacity: 0 })
      .to(transitionCover.current, {
        x: directionTo,
        ease: 'power1.easeInOut',
        duration: seconds / 2,
      });
  };

  // checking to see when the vieport is visible to the user
  //   intersection && intersection.intersectionRatio < 0.2
  //     ? fadeOut('.card-container')
  //     : fadeIn('.card-container');

  return (
    <section id="blogs" ref={sectionRef}>
      <Container className="px-0">
        <div className="project-wrapper">
          <div className="section-title">
            <AnimatedText title={'Blogs'} />
          </div>

          <div className="blogs-grid outer">
            {blogs.map((blog, index) => {
              const { title, info, info2, url, repo, img, id, to, subtitle, backgroundImage, readTime } = blog;

              return (
                <div className="card-containerx" key={id} ref={cardsRef}>
                  <BlogsCard title={title} subtitle={subtitle} to={`/blog/${to}`} bImg={backgroundImage} readTime={readTime} exit={{
                    length: 1.2,
                    trigger: ({ exit }) => exitHorizontal(exit, 'left'),
                  }}
                    entry={{
                      delay: 1.0,
                    }} />
                </div>
              );
            })}
          </div>
        </div>
        <NewStrokedLink
          exit={{
            length: 1.0,
            trigger: ({ exit }) => exitHorizontal(exit, 'left'),
          }}
          entry={{
            delay: 1,
          }}
          title='Explore my blog'
          to="/blog"
        />
      </Container>
      <TransitionPortal>
        <div
          ref={transitionCover}
          style={{
            position: 'fixed',
            background: '#131313',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'none',
          }}
        />
      </TransitionPortal>
    </section>
  );
};

export default BlogsBlock;
